import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Field, SelectField } from "./DealsAdmin";

const EMPTY = { slug: "", review_type: "airline", brand_name: "", product_name: "", rating: 4.5, pros: [], cons: [], verdict: "", body_rich_text: "", featured_image: "", author: "JetsetLess Staff" };

export default function ReviewsAdmin() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const load = () => api.get("/reviews?limit=200").then((r) => setItems(r.data.items));
  useEffect(() => { load(); }, []);
  const save = async () => {
    try {
      const body = { ...editing, rating: Number(editing.rating) };
      if (editing.id) await api.put(`/reviews/${editing.id}`, body);
      else await api.post("/reviews", body);
      toast.success("Saved"); setEditing(null); load();
    } catch { toast.error("Save failed"); }
  };
  const del = async (id) => { if (!confirm("Delete?")) return; await api.delete(`/reviews/${id}`); load(); };
  return (
    <div className="p-8 md:p-10">
      <div className="flex justify-between mb-6">
        <div><div className="overline text-[#B4533C]">Reviews</div><h1 className="font-serif text-4xl mt-1">Reviews</h1></div>
        <button onClick={() => setEditing({ ...EMPTY })} className="bg-[#1B3B36] text-white px-5 py-2.5 text-sm" data-testid="new-review-btn">+ New</button>
      </div>
      <div className="border border-[#D6CFC4]">
        <table className="w-full admin-table"><thead className="bg-[#EFECE5]"><tr><th className="p-3 text-left">Brand</th><th className="p-3 text-left">Product</th><th className="p-3 text-left">Type</th><th className="p-3 text-left">Rating</th><th></th></tr></thead><tbody>
          {items.map((r) => (
            <tr key={r.id} className="border-t border-[#D6CFC4]">
              <td className="p-3"><button onClick={() => setEditing(r)} className="hover:text-[#B4533C]">{r.brand_name}</button></td>
              <td className="p-3 text-xs">{r.product_name}</td>
              <td className="p-3 text-xs font-mono">{r.review_type}</td>
              <td className="p-3 text-xs font-mono">{r.rating}</td>
              <td className="p-3 text-right"><button onClick={() => del(r.id)} className="text-[#B4533C] text-xs">Delete</button></td>
            </tr>
          ))}
        </tbody></table>
      </div>
      {editing && (
        <div className="fixed inset-0 bg-black/40 z-50 grid place-items-center p-6 overflow-y-auto">
          <div className="bg-white border border-[#D6CFC4] p-8 w-full max-w-3xl max-h-[90vh] overflow-y-auto">
            <h2 className="font-serif text-2xl mb-4">{editing.id ? "Edit" : "New"} Review</h2>
            <div className="grid md:grid-cols-2 gap-3">
              <SelectField label="Type" v={editing.review_type} k="review_type" e={setEditing} opts={["airline","hotel","lounge","card","gear"]} />
              <Field label="Slug" v={editing.slug} k="slug" e={setEditing} />
              <Field label="Brand" v={editing.brand_name} k="brand_name" e={setEditing} />
              <Field label="Product" v={editing.product_name} k="product_name" e={setEditing} />
              <Field label="Rating (0-5)" v={editing.rating} k="rating" e={setEditing} type="number" />
              <Field label="Featured Image URL" v={editing.featured_image} k="featured_image" e={setEditing} />
              <Field label="Author" v={editing.author} k="author" e={setEditing} />
            </div>
            <div className="mt-3"><label className="overline">Pros (one per line)</label>
              <textarea value={editing.pros?.join("\n") || ""} onChange={(e) => setEditing({ ...editing, pros: e.target.value.split("\n").filter(Boolean) })} rows={3} className="w-full border border-[#D6CFC4] px-3 py-2 mt-1 text-sm" />
            </div>
            <div className="mt-3"><label className="overline">Cons (one per line)</label>
              <textarea value={editing.cons?.join("\n") || ""} onChange={(e) => setEditing({ ...editing, cons: e.target.value.split("\n").filter(Boolean) })} rows={3} className="w-full border border-[#D6CFC4] px-3 py-2 mt-1 text-sm" />
            </div>
            <div className="mt-3"><label className="overline">Verdict</label>
              <textarea value={editing.verdict} onChange={(e) => setEditing({ ...editing, verdict: e.target.value })} rows={2} className="w-full border border-[#D6CFC4] px-3 py-2 mt-1 text-sm" />
            </div>
            <div className="mt-3"><label className="overline">Body (HTML)</label>
              <textarea value={editing.body_rich_text} onChange={(e) => setEditing({ ...editing, body_rich_text: e.target.value })} rows={6} className="w-full border border-[#D6CFC4] px-3 py-2 mt-1 text-sm font-mono" />
            </div>
            <div className="mt-5 flex gap-3">
              <button onClick={save} className="bg-[#1B3B36] text-white px-5 py-2.5 text-sm" data-testid="save-review-btn">Save</button>
              <button onClick={() => setEditing(null)} className="border border-[#D6CFC4] px-5 py-2.5 text-sm">Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
